export enum DirectAnswersId {
    //Positive Aswers
    externalApk = '018d2180-e49f-79c3-8b7c-01fcf2706117',
    propertyInsurance = '018d2180-e49f-79c3-8b7c-01fcf35086ed',
    businessActivity = '018d2180-e49f-79c3-8b7c-01fcf458f9a4',
    businessActivityInGarageOrFarmBuilding = '018d2180-e49f-79c3-8b7c-01fcf5c5511f',
    availableBusinessActivity = '018d2180-e49f-79c3-8b7c-01fcf7300694',
    businessActivityArea = '018d2180-e49f-79c3-8b7c-01fcf823b20c',
    farm = '018d2180-e49f-79c3-8b7c-01fcf8776a90',
    onlyHouse = '018d2180-e49f-79c3-8b7c-01fcf98c799d',
    oc = '018d2180-e49f-79c3-8b7c-01fcf9f3d561',
    nnw = '018d2180-e49f-79c3-8b7c-01fcfa6bef4f',

    // Negative Answers
    externalApk_No = '018d2180-e49f-79c3-8b7c-01fcf29bb88f',
    propertyInsurance_No = '018d2180-e49f-79c3-8b7c-01fcf41869dd',
    businessActivity_No = '018d2180-e49f-79c3-8b7c-01fcf549bcbf',
    businessActivityInGarageOrFarmBuilding_No = '018d2180-e49f-79c3-8b7c-01fcf7f9bee0',
    availableBusinessActivity_No = '018d210e-48e1-7dee-8c38-38a61da4d2be',
    businessActivityArea_No = '018d2180-e49f-79c3-8b7c-01fcf82f5761',
    farm_No = '018d2180-e49f-79c3-8b7c-01fcf8a88d24',
    onlyHouse_No = '018d2180-e49f-79c3-8b7c-01fcf9d5dcd5',
    oc_No = '018d2180-e49f-79c3-8b7c-01fcfa5ca470',
    nnw_No = '018d2180-e49f-79c3-8b7c-01fcfa865774',
}